/* eslint-disable */
import { getLocalData } from 'hooks/useAuth';

let cachedPermissions = null;
let cachedV2Permissions = null;

export function getValidMenus(menus, auth, uiVersion = null) {
	const isNewUI = uiVersion === 'new';
	const userType = auth?.user_type;
	const v1Search = auth?.permissions?.search;
	const v1Allowed = v1Search ? [...v1Search, 'dashboard'] : [];
	const v2Allowed = auth?.v2_permissions?.search || [];

	const isAllowed = (item) => {
		const module = item?.module;
		if (v1Allowed.includes('all') || v1Allowed.includes(module)) return true;
		return (
			isNewUI && !!item?.v2Only && (v2Allowed.includes('all') || v2Allowed.includes(module))
		);
	};

	// Step 1: Filter by UI version (remove oldUIOnly routes if in new UI)
	let versionFilteredMenus = menus;
	if (isNewUI) {
		versionFilteredMenus = menus?.filter((item) => !item.oldUIOnly);
	}

	// Step 2: Filter by module permissions
	const filteredMenus =
		v1Allowed[0] === 'all'
			? versionFilteredMenus
			: versionFilteredMenus?.filter((item) => isAllowed(item));

	// Step 3: Additionally filter children by excludedUserTypes / includedUserTypes
	// (includedUserTypes, when set, is an allow-list: only those roles see the child).
	return filteredMenus.map((item) => {
		if (item.children) {
			return {
				...item,
				children: item.children.filter(
					(child) =>
						!child.excludedUserTypes?.includes(userType) &&
						(!child.includedUserTypes || child.includedUserTypes.includes(userType))
				),
			};
		}
		return item;
	});
}

export function isValidAPIRequest(URL, data, version = undefined) {
	const isV2 = version === 'v2';

	if (isV2) {
		if (!cachedV2Permissions) {
			cachedV2Permissions = getLocalData().v2_permissions || {};
		}
	} else {
		if (!cachedPermissions) {
			cachedPermissions = getLocalData().permissions || {};
		}
	}

	const permissions = isV2 ? cachedV2Permissions : cachedPermissions;

	// Strip query params for matching (e.g. '/search?foo=1' -> '/search')
	const baseUrl = URL?.split('?')[0] || URL;

	switch (baseUrl) {
		case '/search':
			return (
				permissions.search?.includes(data?.search_type) ||
				permissions.search?.includes('all')
			);
		case '/list_search':
			// list_search uses list_search_type; fallback to search permission for compatibility
			return (
				permissions.list_search?.includes(data?.list_search_type) ||
				permissions.list_search?.includes('all')
			);
		case '/create':
			return (
				permissions.create?.includes(data?.create_type) ||
				permissions.create?.includes('all')
			);
		case '/update':
			return (
				permissions.update?.includes(data?.update_type) ||
				permissions.update?.includes('all')
			);
		case '/report':
			// If report permissions don't exist, allow access (for backward compatibility)
			if (!permissions.report) {
				return true;
			}
			return (
				permissions.report?.includes(data?.report_type) ||
				permissions.report?.includes('all')
			);
		case '/dashboard':
			// Reads dashboard_type, not update_type — a dashboard request never carries an
			// update_type, so the old check only ever passed on a literal 'all'.
			return (
				permissions.dashboard?.includes(data?.dashboard_type) ||
				permissions.dashboard?.includes('all')
			);
		case '/trip/filters':
			return (
				permissions.trip_filters?.includes(data?.filters) ||
				permissions.trip_filters?.includes('all')
			);
		default:
			return false;
	}
}

export function findType(URL) {
	const baseUrl = URL?.split('?')[0] || URL;
	switch (baseUrl) {
		case '/search':
			return 'search_type';
		case '/list_search':
			return 'list_search_type';
		case '/create':
			return 'create_type';
		case '/update':
			return 'update_type';
		case '/report':
			return 'report_type';
		case '/dashboard':
			return 'dashboard_type';
		default:
			return '';
	}
}
